// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  STORE_DETAILS_LABELS,
  StoreLocatorLabels,
  lblStoredetailsSpecialHoursText,
  lblStoredetailsSpecialHoursTextClosed,
} from '@tcp/core/src/components/features/storeLocator/Labels/StoreLocator.labels';
import style from '../styles/SpecialHours.style';
import { isHolidayThere, getHolidayDate } from '../SpecialHours.utils';

class SpecialHours extends PureComponent {
  storeDetailLabels = getLabelFromCopyOrFromTranslation(STORE_DETAILS_LABELS, StoreLocatorLabels);

  render() {
    const { className, storeTiming, fromDate, toDateDayCount } = this.props;
    const isHoliday = isHolidayThere(storeTiming, fromDate, toDateDayCount);
    const [specialHoursText1, specialHoursText2] =
      renderLabel(
        this.storeDetailLabels[lblStoredetailsSpecialHoursText],
        lblStoredetailsSpecialHoursText
      )?.split('-') || [];

    if (!isHoliday) {
      return null;
    }
    const holidayDate = getHolidayDate(isHoliday?.date);
    const specialHoursClosed =
      renderLabel(
        this.storeDetailLabels[lblStoredetailsSpecialHoursTextClosed],
        lblStoredetailsSpecialHoursTextClosed
      ) || '';

    if (isHoliday.closed) {
      return (
        <div className={className}>
          <div className="special-hours-wrapper">
            <div className="heading-text">{isHoliday.dayName}</div>
            <div className="special-holiday-line2-wrapper">
              <div className="special-hours-msg">{specialHoursClosed}</div>
              <div className="line2-date">{holidayDate}</div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={className}>
        <div className="special-hours-wrapper">
          <div className="heading-text">{isHoliday.dayName}</div>
          <div className="special-hours-msg">{specialHoursText1}</div>
          <div className="special-holiday-line2-wrapper">
            <div className="line2-time">{isHoliday.value?.[0]}</div>
            <div className="line2-on">{specialHoursText2}</div>
            <div className="line2-date">{holidayDate}</div>
          </div>
        </div>
      </div>
    );
  }
}

SpecialHours.propTypes = {
  className: PropTypes.string.isRequired,
  storeTiming: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape([])]),
    })
  ),
};

SpecialHours.defaultProps = {
  storeTiming: [],
};
export default withStyles(SpecialHours, style);
